import React from 'react';
import { Icon } from '../common/commonModels';
import TileComponent from '../common/components/TileComponent';
import { Document, UploadState } from '../models/document';
import Link from '../common/Link';
import { Truck } from '../models/truck';
import { FlexDirection, FlexBox, AlignItems } from '../utils/css-classes';

interface Props {
  truck: Truck;
  document: Document;
  iconClassName: Icon;
  onClick: () => void;
  uploadDocument: (truck: Truck, document: Document) => void;
  highlight?: string;
}

// tslint:disable-next-line:function-name
export default function DocumentTileComponent({
  document,
  iconClassName,
  onClick,
  uploadDocument,
  truck,
  highlight,
}: Props) {
  const statesToDisplayLink = [UploadState.UPLOAD_REQUIRED, UploadState.FAILURE];

  const displayLink = Boolean(
    document.manualUploadState && statesToDisplayLink.includes(document.manualUploadState),
  );

  const uploadLink = displayLink ?
    <Link text={document.manualUploadState === UploadState.FAILURE ? 'Retry' : 'Upload'}
      onClick={() => uploadDocument(truck, document)}/> :
    null;

  const manualUploadStateIconClasses = () => {
    switch (document.manualUploadState) {
      case 'SUCCESS':
        return 'fa-check text-success';
      case 'FAILURE':
        return 'fa-warning text-danger';
      case 'UPLOADING':
        return 'fa-cloud-upload-alt pulse text-info';
      default:
        return undefined;
    }
  };

  return (
    <div className={`${FlexBox.FLEX} ${FlexDirection.COLUMN} ${AlignItems.CENTER}`}>
      <TileComponent
        title={document.fileName}
        iconClassName={iconClassName}
        onClick={onClick}
        paddingClass="pt-4 pb-2"
        bottomRightIconClassName={manualUploadStateIconClasses()}
        highlight={highlight}
      />
      {uploadLink}
    </div>
  );
}
